import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: true,
    name: 'bootstrapObjectToDate',
})
export class BootstrapObjectToDatePipe implements PipeTransform {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
    transform(value: any, ...args: any[]): any {
        if (value && typeof value === 'object') {
            return new Date(value.year, value.month - 1, value.day);
        }
        return value;
    }
}
